<template>
  <el-dialog v-if="show"
             v-dialog-drag
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :visible="show"
             class="mydialog"
             title="标书异常项对比预览"
             @close="close">
    <div slot="title" style="display: flex;">
      <div class="mainTitle">异常详情</div>
      <div style="flex:1;"></div>
      <div :class="{maxIcon:!fullscreen, minIcon:fullscreen}" style="width: 20px;cursor: pointer;margin-right:60px;"
           @click="changeScreen">
      </div>
    </div>
    <div style="flex:1;height:1px;display: flex;flex-direction: column;padding: 15px;box-sizing: border-box;position: relative">
      <div class="tagContainer">
        <div style="width: 40px">
          <div v-if="isOverflow" class="left_arrow" @click="getPre"></div>
        </div>
        <div class="tagContainer_outer1">
          <div
              :style="{ left: current_innerLeft + 'px' }"
              class="tagContainer_inner1"
          >
            <div v-for="(item,idx) in companyList" :key="idx" :class="{activeTag:item.org_name==currentCompany}"
                 class="tag"
                 @click="changeTag(item)">
              {{ item.org_name }}
              <span>
              （
              <span
                  :class="{
                  red: item.sim_num !== 0,
                    green: item.sim_num == 0,
                }"
              >{{ item.sim_num }}个</span
              >异常 ）</span
              >
            </div>
          </div>
        </div>
        <div style="width: 100px; display: flex">
          <div v-if="isOverflow" class="right_arrow" @click="getNext"></div>
          <div v-if="isOverflow" class="more_icon" @click="ToggleshowFloat"></div>
        </div>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="文本对比结果" name="textSimilar" ></el-tab-pane>
        <el-tab-pane label="图片对比结果" name="imageSimilar" v-if="hasImg"></el-tab-pane>
        <el-tab-pane  label="作者雷同" name="authorSimilar" v-if="hasAuthor"></el-tab-pane>
        <el-tab-pane  label="错别字" name="errTextSimilar" v-if="hasErrText"></el-tab-pane>
      </el-tabs>
      <div style="flex:1;height: 1px;display: flex;flex-direction: column;">
        <textCmp :companyData="companyData" v-if="activeTab == 'textSimilar'"></textCmp>
        <imgCmp v-if="activeTab == 'imageSimilar'" :companyData="companyData"></imgCmp>
        <authorCmp v-if="activeTab=='authorSimilar'" :companyData="companyData"></authorCmp>
        <errText v-if="activeTab=='errTextSimilar'" :companyData="companyData"></errText>
      </div>
      <div v-if="floatShow" class="floatTagContainer">
        <div style="width: 100%; height: 100%; overflow: auto">
          <div v-for="(item,idx) in companyList"
               :key="idx"
               :class="{ activefloatTag: item.org_name == currentCompany }"
               class="floatTag"
               @click="changeTag(item)"
          >
            {{ item.org_name }}
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mapState} from "vuex";
import {getCompanyDataByName} from "@/api/pdf";
import textCmp from "@/views/pdf/detailCmpExample/textCmp";
import authorCmp from "@/views/pdf/detailCmpExample/authorCmp";
import imgCmp from "@/views/pdf/detailCmpExample/imgCmp";
import errText from "@/views/pdf/detailCmpExample/errText";
export default {
  name: "detail",
  components:{
   textCmp,
    authorCmp,
    imgCmp,
    errText
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    tagKey: {
      type: String,
      required: true
    },
    companyList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOverflow: false,
      current_innerLeft: 0,
      innerWidth: 0,
      outerWidth: 0,
      floatShow: false,
      currentCompany: "",
      companyData: {},
      fullscreen: false,
      activeTab:"textSimilar"
    }
  },
  mounted() {
    this.currentCompany = this.tagKey;
    this.getCompanyDataByName();
    this.$nextTick(() => {
      this.checkOverflow()
    })
    document.addEventListener('click', this.handleDocumentClick) // 给document添加一个点击事件
    document.addEventListener('fullscreenchange', this.handleListener)
    document.addEventListener('mozfullscreenchange', this.handleListener)
    document.addEventListener('webkitfullscreenchange', this.handleListener)
    document.addEventListener('msfullscreenchange', this.handleListener)
  },
  methods: {
    /**
     * 切换标签
     */
    changeTag(item) {
      if (this.currentCompany == item.org_name) {

      } else {
        this.currentCompany = item.org_name;
        this.getCompanyDataByName();
      }
    },
    /**
     * 获取当前选中企业的相似数据
     */
    async getCompanyDataByName(init = false) {
      let res = await getCompanyDataByName({
//         project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
// sign_name: 1710312137,
        project: this.projectId,
        sign_name: this.sign_name,
        org_name: this.currentCompany
      });
      this.companyData = res.data;
    },

    /**
     * 向前
     */
    getPre() {
      if (this.current_innerLeft >= 0) {

      } else {
        this.current_innerLeft = this.current_innerLeft + this.outerWidth
      }
    },
    /**
     * 向后
     */
    getNext() {
      if (this.current_innerLeft - this.outerWidth <= 0 - this.innerWidth) {

      } else {
        this.current_innerLeft = this.current_innerLeft - this.outerWidth
      }
    },

    /**
     * 判断是否显示更多
     */
    checkOverflow() {
      const outer = document.getElementsByClassName('tagContainer_outer1')[0]
      const inner = document.getElementsByClassName('tagContainer_inner1')[0]
      this.innerWidth = inner.offsetWidth
      this.outerWidth = outer.offsetWidth
      if (this.outerWidth > this.innerWidth) {
        this.isOverflow = false
      } else {
        this.isOverflow = true
      }
    },
    /**
     *
     *点击浮窗外部元素 自动关闭浮窗
     */
    handleDocumentClick(e) {
      if (e.target.classList.contains('more_icon')) {
        return
      }
      this.tempshow = false
      if (e.target.classList.contains('floatTagContainer')) {
        this.tempshow = true
      } else {
        if (e.target.parentNode) {
          this.checkParent(e.target.parentNode)
        }
      }

      if (!this.tempshow) {
        this.floatShow = false
      }
    },
    /**
     * 递归查找父元素
     * @param parent
     */
    checkParent(parent) {
      if (parent && parent.classList) {
        if (parent.classList.contains('floatTagContainer')) {
          this.tempshow = true
        }
      }
      if (parent.parentNode) {
        this.checkParent(parent.parentNode)
      }
    },
    /**
     * 切换是否显示浮窗
     */
    ToggleshowFloat() {
      this.floatShow = !this.floatShow

    },
    close() {
      this.$emit('close')
    },
    changeScreen() {
      let element = document.querySelector(".mydialog .el-dialog");
      if (!this.fullscreen) {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          //FireFox
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullScreen) {
          //Chrome等
          element.webkitRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          //IE11
          element.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    handleListener() {
      this.fullscreen = !this.fullscreen;
    },
  },
  computed: {
    ...mapState('pdf', ['projectId', 'sign_name','hasImg','hasAuthor','hasErrText']),
    show() {
      return this.visible
    },

  },
  destroyed() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('fullscreenchange', this.handleListener)
    document.removeEventListener('mozfullscreenchange', this.handleListener)
    document.removeEventListener('webkitfullscreenchange', this.handleListener)
    document.removeEventListener('msfullscreenchange', this.handleListener)
  }
}
</script>
<style lang="scss" scoped>
.tagContainer {
  height: 37px;
  display: flex;
  .left_arrow {
    width: 40px;
    height: 35px;
    background-image: url("~@/assets/image/left.svg");
    background-repeat: no-repeat;
    background-position: center;
    transform: rotate(180deg);
    cursor: pointer;
  }

  .tagContainer_outer1 {
    overflow: hidden;
    position: relative;
    flex: 1;
  }

  .tagContainer_inner1 {
    white-space: nowrap;
    position: absolute;
    transition: all 0.5s;

    .tag {
      padding: 0 10px;
      line-height: 35px;
      background: #fff;
      box-sizing: border-box;
      border: 1px solid rgba(187, 207, 224, 1);
      border-radius: 3px 3px 0 0;
      margin-right: 10px;
      cursor: pointer;
      display: inline-block;
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
    }

    .activeTag {
      background: #d8e6ff;
      border-radius: 3px 3px 0 0;
      box-sizing: border-box;
    }
  }

  .right_arrow {
    width: 40px;
    height: 35px;
    background-image: url("~@/assets/image/right.svg");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .more_icon {
    width: 40px;
    height: 35px;
    background-image: url("~@/assets/image/more.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 26px 26px;
    cursor: pointer;
  }
}

.listContainer {
  flex: 1;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border: 1px solid rgba(163, 188, 208, 1);
  padding: 8px;
  height: 700px;
  min-height: 700px;
  min-width: 1460px;
}

.floatTagContainer {
  width: 250px;
  height: calc(100% - 200px);
  border: 1px solid rgba(163, 188, 208, 1);
  position: absolute;
  top: 60px;
  right: 0;
  z-index: 99999;
  background-color: #fff;

  .floatTag {
    height: 39px;
    line-height: 39px;
    color: #333;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    margin: 5px;
  }

  .activefloatTag {
    color: #1b6fbe;
    font-weight: 700;
    font-style: normal;
    background-color: rgba(218, 233, 255, 1);
  }

  &::before {
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgba(163, 188, 208, 1);
    position: absolute;
    right: 25px;
    top: -8px;
  }

  &::after {
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    position: absolute;
    right: 25px;
    top: -6px;
  }
}

.offlineContainer {
  width: 350px;
  height: 150px;
  position: absolute;
  top: calc(50% - 75px);
  left: calc(50% - 175px);

  .offline_img {
    width: 107px;
    height: 107px;
    display: block;
    margin: 0 auto;
  }
}
.red {
  color: #d9001b;
}

.green {
  color: #13b002;
}
.maxIcon {
  width: 20px;
  background-image: url("~@/assets/image/max.png");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.minIcon {
  width: 20px;
  background-image: url("~@/assets/image/min.png");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
